import { matchPath, NavLink, useLocation } from "react-router-dom";
import React from "react";

import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import { NavItemProps } from "./types";

const NavItem: React.FC<NavItemProps> = ({ ...props }) => {
  const { pathname } = useLocation();
  if (props.type === "single") {
    const { href, title } = props;

    return (
      <NavigationMenuItem>
        <NavigationMenuLink asChild>
          <NavLink to={href} end={href === "/"} className={navigationMenuTriggerStyle()}>
            {title}
          </NavLink>
        </NavigationMenuLink>
      </NavigationMenuItem>
    );
  }
  const { title, menuItems } = props;
  const isOddClassName = menuItems.length % 2 !== 0 ? "last:col-span-2" : "";
  return (
    <NavigationMenuItem className="relative">
      <NavigationMenuTrigger
        data-active={menuItems.some((item) => matchPath({ path: item.href, end: false }, pathname)) ? "" : undefined}
      >
        {title}
      </NavigationMenuTrigger>
      <NavigationMenuContent className={props.align === "start" ? "left-0 right-auto" : undefined}>
        <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
          {menuItems.map((item) => (
            <li key={item.title} className={isOddClassName}>
              <NavigationMenuLink asChild>
                <NavLink
                  to={item.href}
                  className="h-full block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground aria-[current=page]:bg-accent aria-[current=page]:text-accent-foreground"
                >
                  <div className="flex gap-1 text-sm font-medium leading-none">
                    {item.icon}
                    {item.title}
                  </div>
                  <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">{item.description}</p>
                </NavLink>
              </NavigationMenuLink>
            </li>
          ))}
        </ul>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};

export default NavItem;
